import React, {Component} from 'react';

import {TEXT} from '../../utilities/strings';

/**
 * This is a static react port of the cdc template site title
 * public/TemplatePackage/4.0/includes/site-title.html
 */
export default class TemplateSiteTitle extends Component {

  render() {
    return (
      <div className="container-fluid site-title">
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="display-6 text-white fw-500 pb-1 pt-1 m-0">
                {TEXT.page_header}
              </h1>
              <p className="d-none">
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
